import comp from "./Stepper";
export default comp;
